import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';

const getPendingDeployment = (_, props) => props?.pendingDeployment;
const getDeploymentHistory = (_, props) => props?.deploymentHistory || [];
const getScheduledDeployment = (_, props) => props?.scheduledDeployment;

export const selectPendingDeploymentWithDiff = createSelector(
  [getPendingDeployment],
  pendingDeploymentWithDiff
);

export const selectActiveDeployment = createSelector(
  [getDeploymentHistory],
  (deployments) => {
    if (isEmpty(deployments)) {
      return null;
    }

    return deployments.reduce(
      (prev, curr) => (curr.timestamp > prev.timestamp ? curr : prev)
    );
  }
);

export const getPagePathsForDataOnly = createSelector(
  [getScheduledDeployment],
  (scheduledDeployment) => {
    if (!scheduledDeployment) {
      return null;
    }

    return scheduledDeployment.map(d => ({
      _id: d._id,
      scheduledBy: d.scheduledBy,
      version: d.version,
      bucketName: d.bucketName,
      pages: d.data.pages.map(p => p.path),
      deployAt: d.deployAt,
      state: d.state,
      status: d.status,
      notes: d.notes
    }));
  }
);

function pendingDeploymentWithDiff(pendingDeployment) {

  if (!pendingDeployment) {
    return null;
  }

  return {
    ...pendingDeployment,
    added: pendingDeployment.added.map((page) => {
      const { commitedVersion, versions } = page;
      const safeVersions = Array.isArray(versions) ? versions : [];
      const nextVersion = safeVersions.find(v => v.versionId === commitedVersion) || null;

      return {
        ...page,
        nextVersion
      };
    }).filter(page => page.nextVersion)
  };
}
